import { createSelector } from 'reselect';
import pageNames from '../../routes/pageNames';

export const getAppState = state => state.get('app');
export const getPathname = state => state.getIn([
  'router',
  'location',
  'pathname'
]);
export const getMainPathname = createSelector(
  getPathname,
  pathName => pathName.split('/').slice(0, 2).join('/')
);
export const getPageName = createSelector(
  getPathname,
  getMainPathname,
  (pathName, mainPathName) => pageNames[pathName] || pageNames[mainPathName]
);
export const isStorageAvailable = state => state.getIn(['app', 'storageAvailable']);
